import get from 'lodash.get';
import React from 'react';
import _ from 'underscore';
import { ID, l, withCodes2 } from 'app/blocks/common/codes';

const orcidIdFields = [
    { title: 'First Name', path: 'user.firstName' },
    { title: 'Last Name', path: 'user.lastName' },
    { title: 'Primary Email', path: 'user.primaryEmailAddr' },
    { title: 'Country', path: 'user.addresses.correspondenceAddress.country.countryName' },
];

function OrcidDataModal({ orcidData, errors }) {
    let hasValidImportedFields = false;

    return (
        <div className="OrcidDataModal">
            {!_.isEmpty(orcidData) && (
                <div className="OrcidDataModal-OrcidData">
                    <div
                        className="OrcidDataModal-Label"
                        dangerouslySetInnerHTML={{ __html: l('ORCID_POP_UP.SUCCESSFULLY_IMPORTED') }}
                    />
                    {/* eslint-disable-next-line array-callback-return,consistent-return */}
                    {orcidIdFields.map((item, key) => {
                        const val = get(orcidData, item.path);

                        if (!_.isEmpty(val)) {
                            hasValidImportedFields = true;
                            const { title } = item;
                            const value = val.toString();
                            return (
                                // eslint-disable-next-line react/no-array-index-key,react/jsx-no-comment-textnodes
                                <div key={`OrcidDataModalContent-field-${key}`}>
                                    {`${title}:`}
                                    <span>{value}</span>
                                </div>
                            );
                        }
                    })}
                    {!hasValidImportedFields && ' None'}
                </div>
            )}
            {!_.isEmpty(errors) && (
                <div className="OrcidDataModal-OrcidErrors">
                    <div
                        className="OrcidDataModal-Label"
                        dangerouslySetInnerHTML={{ __html: l('ORCID_POP_UP.NOT_IMPORTED') }}
                    />
                    {errors.map((item, key) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={key} dangerouslySetInnerHTML={{ __html: item }} />
                    ))}
                </div>
            )}
        </div>
    );
}

export default withCodes2(ID.ORCID_POP_UP)(OrcidDataModal);
